module.exports = __webpack_public_path__ + "static/media/starmemesLogo.bcbcda39.png";